var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, bindable } from "aurelia-framework";
import { transient } from "aurelia-dependency-injection";
import { EventAggregator } from "aurelia-event-aggregator";
import { Messages } from "../../../configuration/event-messages.constants";
import * as Enumerable from "linq";
import { BindingSignaler } from "aurelia-templating-resources";
var rangy = require("rangy");
import { bindingMode } from "aurelia-binding";
var TextBoxAutoComplete = /** @class */ (function () {
    function TextBoxAutoComplete(eventAggrigator, signaler) {
        var _this = this;
        this.eventAggrigator = eventAggrigator;
        this.signaler = signaler;
        this.label = "";
        this.value = "";
        this.prefix = "{";
        this.suffix = "}";
        this.placeholder = "";
        this.displayMemberPath = "name";
        this.valueMemberPath = "value";
        this.colorMemberPath = "color";
        this.itemSource = [];
        this.multiline = false;
        this.ignoreHtml = false;
        this.items = [];
        this.currentIndex = 0;
        this.hide = function () {
            _this.shown = false;
        };
        this.focus = function (event) {
            _this.focused = true;
        };
        this.blur = function (event) {
            _this.focused = false;
        };
        this.keypress = function (event) {
            if (_this.suppressKeyPressRepeat)
                return;
            _this.move(event);
        };
        this.keyup = function (event) {
            switch (event.keyCode) {
                case 40: // down arrow
                case 38: // up arrow
                case 16: // shift
                case 17: // ctrl
                case 18: // alt
                    break;
                case 9: // tab
                case 13: // enter
                    if (_this.shown)
                        _this.select(_this.items[_this.currentIndex]);
                    break;
                case 27: // escape
                    if (!_this.shown)
                        return;
                    _this.hide();
                    break;
                default:
                    _this.lookup(event);
            }
            _this.inputChanged();
        };
        this.keydown = function (event) {
            if (event.key == _this.prefix) {
                var pos = _this.getCaretPixelPosiotion(_this.input);
                _this.contextMenuLeft = pos.x;
                _this.contextMenuTop = pos.y + 18;
            }
            if (event.keyCode == 13 && !_this.multiline) {
                event.preventDefault();
            }
            _this.suppressKeyPressRepeat = Enumerable.from([40, 38, 9, 13, 27]).contains(event.keyCode);
            _this.move(event);
        };
    }
    TextBoxAutoComplete.prototype.valueChanged = function () {
        if (this.ignoreHtml && this.value !== $(this.input).text()) {
            $(this.input).text(this.value);
        }
        else if (!this.ignoreHtml && this.value !== $(this.input).html()) {
            $(this.input).html(this.value);
        }
    };
    TextBoxAutoComplete.prototype.inputChanged = function () {
        if (this.ignoreHtml) {
            this.value = $(this.input).text();
        }
        else {
            this.value = $(this.input).html();
        }
        $(this.input).change();
    };
    TextBoxAutoComplete.prototype.getDisplayName = function (item, highlight) {
        if (highlight === void 0) { highlight = false; }
        if (this.displayMemberPath && item) {
            if (typeof this.displayMemberPath == "function") {
                return this.displayMemberPath(item);
            }
            else {
                return highlight
                    ? this.highlighter(item[this.displayMemberPath])
                    : item[this.displayMemberPath];
            }
        }
        return highlight ? this.highlighter(item) : item;
    };
    TextBoxAutoComplete.prototype.getValue = function (item, highlight) {
        if (highlight === void 0) { highlight = false; }
        if (this.valueMemberPath && item) {
            if (typeof this.valueMemberPath == "function") {
                return this.valueMemberPath(item);
            }
            else {
                return highlight
                    ? this.highlighter(item[this.valueMemberPath])
                    : item[this.valueMemberPath];
            }
        }
        return highlight ? this.highlighter(item) : item;
    };
    TextBoxAutoComplete.prototype.getColorHex = function (item) {
        if (this.colorMemberPath && item) {
            if (typeof this.colorMemberPath == "function") {
                return this.colorMemberPath(item);
            }
            else {
                return item[this.colorMemberPath];
            }
        }
        return item;
    };
    TextBoxAutoComplete.prototype.attached = function () {
        if (this.input) {
            this.valueChanged();
            this.input.addEventListener("focus", this.focus, false);
            this.input.addEventListener("blur", this.blur, false);
            this.input.addEventListener("keypress", this.keypress, false);
            this.input.addEventListener("keyup", this.keyup, false);
            this.input.addEventListener("keydown", this.keydown, false);
        }
        this.subscriptionToDocumentClickEvent = this.eventAggrigator.subscribe(Messages.documentClick, this.hide);
    };
    TextBoxAutoComplete.prototype.detached = function () {
        if (this.input) {
            this.input.removeEventListener("focus", this.focus, false);
            this.input.removeEventListener("blur", this.blur, false);
            this.input.removeEventListener("keypress", this.keypress, false);
            this.input.removeEventListener("keyup", this.keyup, false);
            this.input.removeEventListener("keydown", this.keydown, false);
        }
        if (this.subscriptionToDocumentClickEvent) {
            this.subscriptionToDocumentClickEvent.dispose();
        }
    };
    TextBoxAutoComplete.prototype.move = function (e) {
        if (!this.shown)
            return;
        switch (e.keyCode) {
            case 9: // tab
            case 13: // enter
            case 27: // escape
                e.preventDefault();
                break;
            case 38: // up arrow
                e.preventDefault();
                this.prev(e);
                break;
            case 40: // down arrow
                e.preventDefault();
                this.next(e);
                break;
        }
        e.stopPropagation();
    };
    TextBoxAutoComplete.prototype.next = function (event) {
        var index = this.currentIndex + 1;
        if (index < this.items.length) {
            this.currentIndex++;
        }
    };
    TextBoxAutoComplete.prototype.prev = function (event) {
        var index = this.currentIndex - 1;
        if (index > -1) {
            this.currentIndex--;
        }
    };
    TextBoxAutoComplete.prototype.lookup = function (event) {
        var items;
        this.query = $(this.input).text();
        if (!this.query && this.shown) {
            this.hide();
        }
        items = this.itemSource;
        if (items)
            this.process(items);
        this.signaler.signal("refersh-highlight");
    };
    TextBoxAutoComplete.prototype.process = function (items) {
        var _this = this;
        var items = Enumerable.from(items)
            .where(function (x) { return _this.matcher(x); })
            .toArray();
        items = this.sorter(items);
        if (!items.length) {
            return this.shown ? this.hide() : this;
        }
        this.items = items;
        this.show();
    };
    TextBoxAutoComplete.prototype.sorter = function (items) {
        var beginswith = [];
        var caseSensitive = [];
        var caseInsensitive = [];
        var item;
        while ((item = items.shift())) {
            var text = this.getValue(item);
            if (!text.toLowerCase().indexOf(this.query.toLowerCase()))
                beginswith.push(item);
            else if (text.indexOf(this.query) != -1)
                caseSensitive.push(item);
            else
                caseInsensitive.push(item);
        }
        return beginswith.concat(caseSensitive, caseInsensitive);
    };
    TextBoxAutoComplete.prototype.show = function () {
        this.shown = true;
    };
    TextBoxAutoComplete.prototype.getCaretPixelPosiotion = function (element) {
        var x = 0, y = 0;
        if (window.getSelection) {
            var sel = window.getSelection();
            if (sel.rangeCount) {
                var range = sel.getRangeAt(0).cloneRange();
                if (range.getClientRects()) {
                    range.collapse(true);
                    var rect = range.getClientRects()[0];
                    var parent = element.getBoundingClientRect();
                    x = rect.left - parent.left;
                    y = rect.top - parent.top;
                }
            }
        }
        return { x: x, y: y };
    };
    TextBoxAutoComplete.prototype.menuClick = function (e, item) {
        e.stopPropagation();
        e.preventDefault();
        this.select(item);
        $(this.input).focus();
    };
    TextBoxAutoComplete.prototype.select = function (item) {
        var val = this.getValue(item);
        var offset = val.length - this.lengthOfQuery + 2;
        if (this.multiline) {
            var regex = new RegExp("<br>", "g");
            while (regex.exec($(this.input).html())) {
                offset++;
            }
        }
        var position = this.getCaretPosition(this.input);
        var color = this.getColorHex(item);
        var newVal = "<strong style='color:" +
            color +
            "'>" +
            this.prefix +
            val +
            this.suffix +
            "</strong>&nbsp;";
        this.pasteHtmlAtCaret(newVal, this.lengthOfQuery + 1, false);
        this.inputChanged();
        this.setCaretPosition(this.input, position + offset);
        this.hide();
    };
    TextBoxAutoComplete.prototype.matcher = function (item) {
        var tquery = this.extractor();
        if (!tquery)
            return false;
        // Set values that will be needed by select() here, because mouse clicks can change them
        this.lengthOfQuery = tquery.length;
        return (this.getValue(item)
            .toLowerCase()
            .indexOf(tquery) != -1);
    };
    TextBoxAutoComplete.prototype.extractor = function () {
        var query = this.query;
        var position = this.getCaretPosition(this.input);
        query = query.substring(0, position);
        var regex = new RegExp("(^|.)(" + this.prefix + "[\\w-]*)$");
        var result = regex.exec(query);
        if (result && result[2])
            return result[2]
                .trim()
                .toLowerCase()
                .substr(this.prefix.length);
        return "";
    };
    TextBoxAutoComplete.prototype.highlighter = function (item) {
        var query = this.extractor().replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
        return item.replace(new RegExp("(" + query + ")", "ig"), function ($1, match) {
            return "<strong>" + match + "</strong>";
        });
    };
    TextBoxAutoComplete.prototype.getCaretPosition = function (containerEl) {
        var range = window.getSelection().getRangeAt(0);
        return this.getCharacterOffsetWithin(range, containerEl);
    };
    TextBoxAutoComplete.prototype.getCharacterOffsetWithin = function (range, node) {
        var treeWalker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, {
            acceptNode: function (n) {
                var nodeRange = document.createRange();
                nodeRange.selectNode(n);
                return nodeRange.compareBoundaryPoints(Range.END_TO_END, range) < 1
                    ? NodeFilter.FILTER_ACCEPT
                    : NodeFilter.FILTER_REJECT;
            }
        } // satisfy lib.dom.d.ts type
        );
        var charCount = 0;
        while (treeWalker.nextNode()) {
            charCount += treeWalker.currentNode.length;
        }
        if (range.startContainer.nodeType == 3) {
            charCount += range.startOffset;
        }
        return charCount;
    };
    TextBoxAutoComplete.prototype.setCaretPosition = function (containerEl, index) {
        var charIndex = 0, stop = {};
        var traverseNodes = function (node) {
            if (node.nodeType == 3) {
                var nextCharIndex = charIndex + node.length;
                if (index >= charIndex && index <= nextCharIndex) {
                    rangy.getSelection().collapse(node, index - charIndex);
                    throw stop;
                }
                charIndex = nextCharIndex;
            }
            else if (node.nodeType == 1 &&
                /^(input|br|img|col|area|link|meta|link|param|base)$/i.test(node.nodeName)) {
                // Count an empty element as a single character. The list below may not be exhaustive.
                charIndex += 1;
            }
            else {
                var child = node.firstChild;
                while (child) {
                    traverseNodes(child);
                    child = child.nextSibling;
                }
            }
        };
        try {
            traverseNodes(containerEl);
        }
        catch (ex) {
            if (ex != stop) {
                throw ex;
            }
        }
    };
    TextBoxAutoComplete.prototype.pasteHtmlAtCaret = function (html, offset, selectPastedContent) {
        var sel, range;
        if (window.getSelection) {
            // IE9 and non-IE
            sel = window.getSelection();
            if (sel.getRangeAt && sel.rangeCount) {
                range = sel.getRangeAt(0);
                range.setStart(range.startContainer, range.startOffset - offset);
                range.deleteContents();
                // Range.createContextualFragment() would be useful here but is
                // only relatively recently standardized and is not supported in
                // some browsers (IE9, for one)
                var el = document.createElement("div");
                el.innerHTML = html;
                var frag = document.createDocumentFragment(), node, lastNode;
                while ((node = el.firstChild)) {
                    lastNode = frag.appendChild(node);
                }
                var firstNode = frag.firstChild;
                range.insertNode(frag);
                // Preserve the selection
                if (lastNode) {
                    range = range.cloneRange();
                    range.setStartAfter(lastNode);
                    if (selectPastedContent) {
                        range.setStartBefore(firstNode);
                    }
                    else {
                        range.collapse(true);
                    }
                    sel.removeAllRanges();
                    sel.addRange(range);
                }
            }
        }
        else if ((sel = document["selection"]) && sel.type != "Control") {
            // IE < 9
            var originalRange = sel.createRange();
            originalRange.collapse(true);
            sel.createRange().pasteHTML(html);
            if (selectPastedContent) {
                range = sel.createRange();
                range.setEndPoint("StartToStart", originalRange);
                range.select();
            }
        }
    };
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], TextBoxAutoComplete.prototype, "label", void 0);
    __decorate([
        bindable({ defaultBindingMode: bindingMode.twoWay }),
        __metadata("design:type", String)
    ], TextBoxAutoComplete.prototype, "value", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], TextBoxAutoComplete.prototype, "prefix", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], TextBoxAutoComplete.prototype, "suffix", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], TextBoxAutoComplete.prototype, "placeholder", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Object)
    ], TextBoxAutoComplete.prototype, "displayMemberPath", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Object)
    ], TextBoxAutoComplete.prototype, "valueMemberPath", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Object)
    ], TextBoxAutoComplete.prototype, "colorMemberPath", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Array)
    ], TextBoxAutoComplete.prototype, "itemSource", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], TextBoxAutoComplete.prototype, "multiline", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], TextBoxAutoComplete.prototype, "ignoreHtml", void 0);
    TextBoxAutoComplete = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [EventAggregator,
            BindingSignaler])
    ], TextBoxAutoComplete);
    return TextBoxAutoComplete;
}());
export { TextBoxAutoComplete };
